import React, { useEffect, useRef, useState } from 'react';

export default function RentalsSection() {
  const iframeRef = useRef(null);
  const [frameHeight, setFrameHeight] = useState(900); // initial reserved height
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    function handleMessage(event) {
      if (event.data?.type === 'FH_RESIZE') {
        const newHeight = Number(event.data.height) || 0;
        if (newHeight > 0) {
          setFrameHeight(newHeight);
          setIsLoaded(true);
        }
      }
    }

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 className="section-title bg-white text-center text-primary px-3">
            Rentals
          </h6>
          <h1 className="mb-5">Available Rentals</h1>
          <p className="text-muted">
            Browse live availability and book directly through our secure FareHarbor calendar below.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-12">
            <div
              className="shadow-sm"
              style={{
                borderRadius: '0.5rem',
                overflow: 'hidden',
                position: 'relative',
              }}
            >
              {/* Loading overlay */}
              {!isLoaded && (
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    zIndex: 2,
                  }}
                >
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading booking calendar...</span>
                  </div>
                </div>
              )}

              <iframe
                ref={iframeRef}
                src="/fareharbor-grid.html"
                title="Sunbay Boats – Live Availability & Booking"
                style={{
                  width: '100%',
                  border: 'none',
                  height: `${frameHeight}px`,
                  display: 'block',
                  transition: 'height 0.3s ease', // smooth height adjustment
                }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}